export { default } from './AreaOfOperationList';
